/**
 * The names of the events that can be triggered by the [FacetsMobileMode]{@link FacetsMobileMode} component.
 */
export class FacetsMobileModeEvents {
  /**
   * The name of the event that gets triggered when the facets pop-up (or modal) is opened in mobile mode.
   */
  public static popupOpened = 'popupOpened';
  /**
   * The name of the event that gets triggered when the facets pop-up (or modal) is closed in mobile mode.
   */
  public static popupClosed = 'popupClosed';
}



// WEBPACK FOOTER //
// ./src/events/FacetsMobileModeEvents.ts